import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/licitacao/listar/form_edit'
import Head from '../../../../components/head'
import Footer from '../../../../components/footer'


function EditarLicScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Licitação" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default EditarLicScreen;